import React from 'react';

function Ring({ loading }) {
  if (!loading) return null;

  return (
    <div className="ui center aligned container head">
      <div className="spinner-div">
        <div className="middle-of-page">
          <div className="loading-ring"></div>
        </div>
      </div>
    </div>
  );
}

export { Ring };
